import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';

import { useRouter } from 'next/router';

import api from 'services/api';
import { IResponse } from 'store/modules/common-types';
import { useSelector } from 'react-redux';
import { IState } from 'store';
import { IConfigApplicationProps } from 'store/modules/config';

export interface ISecurityCheckProps {
  local: 'ALTERARSENHA' | 'ALTERARCADASTROCLIENTE' | 'CADASTRARCLIENTE';
}

const SecurityCheckContext = createContext({});

export const SecurityCheckProvider = ({ children }) => {
  const router = useRouter();
  const config = useSelector<IState, IConfigApplicationProps>(
    state => state.config.config,
  );

  const [loading, setLoading] = useState(true);

  const checkSecurity = useCallback(async () => {
    try {
      let response: IResponse;

      if (
        router.asPath.includes('/ultrapremio') &&
        !router.asPath.includes('/central-do-cliente/ultrapremio')
        //  || router.asPath.includes('/ultracompare')
      ) {
        router.replace('/404');
      }

      if (
        (router.asPath.includes('/central-do-cliente') ||
          router.asPath.includes('/checkout') ||
          router.asPath === '/') &&
        !router.asPath.includes('/verificacao-seguranca')
      ) {
        if (
          router.asPath.includes('/central-do-cliente/alterar-cadastro') &&
          config.geral?.habilitarCodigoVerificacaoAlterarCadastroCliente
        ) {
          response = await api.get('codigo-verificacao/habilitar-tela', {
            params: {
              local: 'ALTERARCADASTROCLIENTE',
            },
          });
        } else if (
          router.asPath.includes('/central-do-cliente/alterar-senha') &&
          config.geral?.habilitarCodigoVerificacaoAlterarSenha
        ) {
          response = await api.get('codigo-verificacao/habilitar-tela', {
            params: {
              local: 'ALTERARSENHA',
            },
          });
        } else {
          response = await api.get('codigo-verificacao/habilitar-tela', {
            params: {
              local: 'CADASTRARCLIENTE',
            },
          });
        }

        if (response.data) {
          router.push(`/verificacao-seguranca?ReturnUrl=${router.asPath}`);
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [router]);

  useEffect(() => {
    checkSecurity();
  }, [router]);

  return (
    <SecurityCheckContext.Provider value={{}}>
      {!loading && children}
    </SecurityCheckContext.Provider>
  );
};

export function useSecurityCheck() {
  const context = useContext(SecurityCheckContext);

  if (!context) {
    throw new Error(
      'useSecurityCheck must be used within a SecurityCheckProvider',
    );
  }

  return context;
}
